
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_1kosq_6qwvb_9",
  "breadcrumb": "awsui_breadcrumb_1kosq_6qwvb_13",
  "ghost-breadcrumb": "awsui_ghost-breadcrumb_1kosq_6qwvb_14",
  "icon": "awsui_icon_1kosq_6qwvb_17",
  "anchor": "awsui_anchor_1kosq_6qwvb_27",
  "text": "awsui_text_1kosq_6qwvb_75",
  "last": "awsui_last_1kosq_6qwvb_94"
};
  